// FactSlider.js
import React, { Component } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

// CSS styles as a string for horizontal transitions with fixed positioning
const sliderCSS = `
/* The wrapper ensures both components overlap during the transition */
.fact-slider-wrapper {
  position: relative;
  min-height: 150px; /* Adjust this value to fit your content */
  margin-top: 20px; /* If you want spacing above the slider */
}

/* Each fact content is absolutely positioned so they overlap */
.fact-slider-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box; /* Ensure padding and border are included in width */
}

/* Entering animation: start off-screen to the right */
.fact-slider-enter {
  opacity: 0;
  transform: translateX(100%);
}
.fact-slider-enter-active {
  opacity: 1;
  transform: translateX(0);
  transition: opacity 500ms ease-in, transform 500ms ease-in;
}

/* Exiting animation: slide out to the left */
.fact-slider-exit {
  opacity: 1;
  transform: translateX(0);
}
.fact-slider-exit-active {
  opacity: 0;
  transform: translateX(-100%);
  transition: opacity 500ms ease-in, transform 500ms ease-in;
}

.fact-title {
  color: #FCB727;
}
`;

const facts = [
    {
        title: "Automated Checklist Monitoring",
        whatItDoes: "Monitors your flight phase and automatically reminds you to complete necessary checklists.",
        whyItHelps: "Reduces the risk of omitting critical tasks during high workload moments."
    },
    {
        title: "Real-Time Flight Phase Detection",
        whatItDoes: "Analyzes flight data to detect your current phase and provides context-aware alerts.",
        whyItHelps: "Ensures timely reminders for specific actions, enhancing situational awareness."
    },
    {
        title: "Voice-Controlled Data Access",
        whatItDoes: "Retrieves essential flight information like airport frequencies and runway details via voice command.",
        whyItHelps: "Keeps your hands on the controls and minimizes cockpit distractions."
    },
    {
        title: "Emergency Diversion Guidance",
        whatItDoes: "Calculates and relays details for the nearest suitable airport in an emergency.",
        whyItHelps: "Provides quick, actionable information when every second counts."
    },
    {
        title: "Seamless EFB Integration",
        whatItDoes: "Integrates with ForeFlight to manage flight plans and display navigation charts on demand via voice.",
        whyItHelps: "Streamlines workflow and ensures that vital information is always at your fingertips."
    },
    {
        title: "Course Deviation Alerts",
        whatItDoes: "Monitors your flight path and alerts you if you stray from your planned route.",
        whyItHelps: "Helps maintain the correct course, avoiding potential hazards."
    }
];

class FactSlider extends Component {
    constructor(props) {
        super(props);
        // Start with a random fact
        const initialIndex = Math.floor(Math.random() * facts.length);
        this.state = {
            currentIndex: initialIndex
        };
    }

    componentDidMount() {
        // Change fact every 5 seconds
        this.interval = setInterval(() => {
            this.setState(prevState => ({
                currentIndex: (prevState.currentIndex + 1) % facts.length
            }));
        }, 9000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        const currentFact = facts[this.state.currentIndex];
        return (
            <div>
                {/* Inject the CSS */}
                <style>{sliderCSS}</style>
                {/* Wrapper to position the fact boxes absolutely */}
                <div className="fact-slider-wrapper">
                    <TransitionGroup>
                        <CSSTransition
                            key={this.state.currentIndex}
                            timeout={500}
                            classNames="fact-slider"
                        >
                            <div className="fact-slider-content" style={{
                                padding: "15px",
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                            }}>
                                <h3 className="fact-title">{currentFact.title}</h3>
                                <p><strong>What Goose does:</strong> {currentFact.whatItDoes}</p>
                                <p><strong>Pilot's benefit:</strong> {currentFact.whyItHelps}</p>
                            </div>
                        </CSSTransition>
                    </TransitionGroup>
                </div>
            </div>
        );
    }
}

export default FactSlider;
